import { render } from "./ReturnBox.vue?vue&type=template&id=26f21188"
import script from "./ReturnBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/returnBox/ReturnBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26f21188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26f21188', __exports__)) {
    console.log('reload')
    api.reload('26f21188', __exports__)
  }
  
  module.hot.accept("./ReturnBox.vue?vue&type=template&id=26f21188", () => {
    console.log('re-render')
    api.rerender('26f21188', render)
  })

}


export default __exports__